//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageNotPaiGongView from "./page-notPaiGong-view";
import PagePaiGongView from "./page-paiGong-view";
import PageNoReturnVisitView from "./page-noReturnVisit-view";
import {GetUserProjects} from "../../../../api/member";

export default {
    name: "index",
    components: {PageNoReturnVisitView, PagePaiGongView, PageNotPaiGongView},
    data() {
        return {
            active: 0,
            currentUser: {
                userId: 0
            },
            projectList: []
        }
    },
    computed: {
        // active() {
        //     return this.$store.state.workOrder.managementActive;
        //     // return this.$store.state.workOrder.workOrderInfo;
        // }
    },
    methods: {
        activeChange(name, title) {
            // console.log(name)
            this.$store.commit('workOrder/setManagementActive', name)
        },
        getCurrentUserByMember() {
            abp.ajax.get('/api/services/app/WorkOrder/GetCurrentUserByMember').then(res => {
                if (res.data.result != null) {
                    this.currentUser = res.data.result;
                    this.getUserProjects();
                }
            })
        },
        getUserProjects() {
            // GetUserProjects(this.currentUser.userId).then(res => {
            //     this.projectList.push(...res.data.result)
            // })
            this.$store.dispatch({
                type:'member/getUserProjects',
                userId:this.currentUser.userId
            })
        }
    },
    created() {
        this.getCurrentUserByMember();
        this.active = this.$store.state.workOrder.managementActive
    }
}
